export enum ChannelType {
  email = 'email',
  telegram = 'telegram',
  slack = 'slack'
}
